module.exports = __webpack_public_path__ + "assets/img/img-1.3ffe070b.png";